// Template IDs
export const TEMPLATE_IDS = {
	GRID: 1,
	MINIMAL: 2,
} as const;

export type TemplateId = (typeof TEMPLATE_IDS)[keyof typeof TEMPLATE_IDS];

// Template names for display
export const TEMPLATE_NAMES = {
	[TEMPLATE_IDS.GRID]: 'Grid Background',
	[TEMPLATE_IDS.MINIMAL]: 'Minimal',
} as const;

// Helper function to get template name
export function getTemplateName(templateId: TemplateId): string {
	return TEMPLATE_NAMES[templateId] || 'Unknown Template';
}

// Helper function to validate template ID
export function isValidTemplateId(templateId: number): templateId is TemplateId {
	return Object.values(TEMPLATE_IDS).includes(templateId as TemplateId);
}
